import apiClient from '../apiClient';
import { DELETE_PAYMENT_SCHEME_DETAIL_URL } from '../apiUrl';

const deletePaymentSchemeDetailApi = Id => {
  return apiClient.delete(DELETE_PAYMENT_SCHEME_DETAIL_URL(Id));
};

export default deletePaymentSchemeDetailApi;
